import http from '@/utils/http'

/**
 * 审核列表
*/
export function getReviewPage(data) {
    return http({
        url: '/dzsd/review/page',
        method: 'post',
        data
    })
  }

/**
 * 修改链接
*/
export function UpdateReviewLink(data) {
    return http({
        url: '/dzsd/review/update/link',
        method: 'post',
        data
    })
  }

/**
 * 修改状态
*/
export function UpdateReviewStatus(data) {
    return http({
        url: '/dzsd/review/update/status',
        method: 'post',
        data
    })
  }

/**
 * 批量导出二维码
*/
export function exportQrcode(data) {
    return http({
        url: '/dzsd/review/import/public/qrcode',
        method: 'post',
        data
    })
  }

/**
 * 二维码
*/
export function getAvailable(params) {
    return http({
        url: '/dzsd/review/verify/available',
        method: 'get',
        params
    })
  }